var React = require('react');

function RarrInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M13.7967 5.51291L9.29669 0.762908C9.04377 0.509008 8.50274 0.422083 8.20684 0.702361C7.91192 0.982636 7.91289 1.51486 8.21075 1.79416L11.5077 5.27866H0.75C0.33595 5.27866 0 5.61461 0 6.02866C0 6.44271 0.33595 6.77866 0.75 6.77866H11.5077L8.21075 10.2632C7.91387 10.5415 7.89337 11.0942 8.20684 11.355C8.49589 11.5952 9.03399 11.6059 9.29669 11.2944L13.7967 6.54441C13.9881 6.35301 14.1375 5.84811 13.7967 5.51316V5.51291Z","fill":"#262626"}));
}

RarrInline.defaultProps = {"width":"14","height":"12","viewBox":"0 0 14 12","fill":"none"};

module.exports = RarrInline;

RarrInline.default = RarrInline;
